import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum UserAuthoritiesTypes {
    ADMIN = 'ADMIN',
    BOOKING_OPERATOR = 'BOOKING_OPERATOR',
    CONTENT_MANAGER = 'CONTENT_MANAGER',
    HR_MANAGER = 'HR_MANAGER',
    USER = 'USER',
}

interface IUserAuthorities {
    [value: string]: SimpleObjectInterface;

    ADMIN: SimpleObjectInterface;
    BOOKING_OPERATOR: SimpleObjectInterface;
    CONTENT_MANAGER: SimpleObjectInterface;
    HR_MANAGER: SimpleObjectInterface;
    USER: SimpleObjectInterface;
}

const USER_AUTHORITIES: IUserAuthorities = {
    ADMIN: {
        name: 'Администратор',
        value: 'ADMIN',
    },
    BOOKING_OPERATOR: {
        name: 'Оператор колл-центра',
        value: 'BOOKING_OPERATOR',
    },
    CONTENT_MANAGER: {
        name: 'Контент-менеджер',
        value: 'CONTENT_MANAGER',
    },
    HR_MANAGER: {
        name: 'HR-менеджер',
        value: 'HR_MANAGER',
    },
    USER: {
        name: 'Пользователь',
        value: 'USER',
    },
};

export default USER_AUTHORITIES;

export const DocumentKindEnumType = TypeService.createEnum<UserAuthoritiesTypes>(UserAuthoritiesTypes, 'UserAuthoritiesTypes');
